/*
 * Copyright (c) 2022 Puratos. All rights reserved.
 */

import React, {FunctionComponent} from "react";
import {Field} from "redux-form";
import {emailValidation, noValidation, required, requiredEmail, requiredMaxLength} from "../../../utils/my-puratos/FormUtils";
import {useI18N} from "../../my-puratos/hoc/withI18N";

interface IProps {
    name: string,
    label?: string,
    type?: "text" | "email",
    maxLength?: number,
    disabled?: boolean,
    isRequired?: boolean,
    infoMsg?: string,
    errorMsg?: string,
    hasError?: boolean,
}

export const InputField: FunctionComponent<IProps> = ({name, label, type = "text", maxLength, disabled = false, isRequired = false, infoMsg = "", errorMsg = "", hasError = false}) => {

    const requiredMaximumLength = maxLength ? requiredMaxLength(maxLength) : noValidation;
    const validation = (isRequired && type === "email") ? [required, requiredEmail, emailValidation] : (isRequired ? [required, requiredMaximumLength] : noValidation);
    return <Field name={name} component={TextInput} label={label} maxLength={maxLength} disabled={disabled}
                  validate={validation} required={isRequired} type={type} infoMsg={infoMsg} errorMsg={errorMsg}
                  hasError={hasError}/>

}

const TextInput = ({input, meta, label, type, maxLength, disabled, required, infoMsg, errorMsg, hasError, ...props}) => {
    const translate = useI18N();
    const error = required && ((hasError && !meta.valid) || (meta.touched && !meta.valid && input?.value?.length > 0));

    return (
        <div className="row">
            <div className={`col-md-6 col-sm-12 form--input ${error ? "form--input__error" : ""} ${meta.active || input.value ? "form--input__content" : ""}`}>
                <label htmlFor={input.name}>{required && <span>*</span>} {translate(label)}</label>
                <input id={input.name} type={type} maxLength={maxLength} disabled={disabled} required={required}
                       className={"form-control"} {...input} {...props}/>
                <span className={"text-very-small"}>{translate(!error ? infoMsg : errorMsg)?.replace("{}", translate(label))}</span>
            </div>
        </div>
    );
}
